import { normalizeChartingMarketSavedSearches } from '@/features/charting-next/adapters/chartingPreferenceAdapters';
import { chartingMarketQueryRepository } from '@/features/charting-next/api/chartingMarketQueryRepository';

export async function fetchChartingSavedSearches() {
    return normalizeChartingMarketSavedSearches(await chartingMarketQueryRepository.listSaved());
}

export function createChartingSavedSearch({ name = '', definition = {} } = {}) {
    return chartingMarketQueryRepository.saveNamed(name, definition);
}

export function renameChartingSavedSearch({ name = '', newName = '' } = {}) {
    return chartingMarketQueryRepository.updateNamed(name, { newName });
}

export function updateChartingSavedSearch({ name = '', newName = '', definition = null } = {}) {
    return chartingMarketQueryRepository.updateNamed(name, { newName, definition });
}

export function deleteChartingSavedSearch(name) {
    return chartingMarketQueryRepository.deleteNamed(name);
}

export function applyChartingSavedSearch(name) {
    return chartingMarketQueryRepository.getSaved(name);
}
